/**
 * App URL prefix (React Router basename / asset mount).
 * Empty string = served at domain root (e.g. https://office.tumma.co/).
 * Legacy subdirectory deploys use "/cloud-office".
 */
export function getCtxPath() {
  const raw = process.env.REACT_APP_API_CTX_PATH;
  if (raw === undefined || raw === null) return "/cld-office";
  const trimmed = String(raw).trim();
  if (trimmed === "" || trimmed === "/") return "";
  return trimmed.replace(/\/$/, "");
}

/** Absolute path to the app home (always starts with /). */
export function getCtxHomeUrl() {
  const path = getCtxPath();
  return path ? `${path}/` : "/";
}

/** Absolute path to staff CRM login. */
export function getStaffLoginUrl() {
  const path = getCtxPath();
  return path ? `${path}/login` : "/login";
}
